<!-- <p>
  juvenile-case-view works!
</p> -->
<div appTableOfContents appStickyHeaders class="container-fluid">
  <div id="juvenile-case-title" class="sticky-header-offset table-of-contents-header-offset">
    <div id="juvenile-case-title-text">
       Juvenile Case <span class="field-code">V017a,V003a</span><span style="font-weight:bold">{{juvenileCase.getCaseCounty()}}</span> County <span style="font-weight:bold">{{juvenileCase.getCaseNumber() + " : " + juvenileCase.getJuvenileNameFromSearch()}}</span> 
      <span class="field-code">V085a</span>{{juvenileCase.getCaseCaption()}} {{juvenileCase.getCaseTypeCaptionDescription()}}
      </div>
      <!-- <div id="juvenile-case-datetime-of-last-update"><span class="field-code">V517</span>
        <span class="search-record-last-updated-info">The displayed information was last updated from the system of record on {{juvenileCase.searchRecordLastUpdateDate | date:'MM/dd/yyyy'}}  at {{juvenileCase.searchRecordLastUpdateDate | date:'jm'}}.</span>
      </div> -->
  </div>
  <div id="juvenile-case-main-content" class="row main-content" >
    <nav id="table-of-contents-nav" [ngClass]="{'opened': tocOpen, 'closed': !tocOpen, 'opening': tocOpening}">
      <ul id="table-of-contents-nav-list" [class.table-of-contents-hidden]="!tocOpen" class="nav nav-pills nav-stacked">

         <!-- Start Attorney Case Detail -->   
         <li class="inline" *ngIf="juvenileCase.getJuvenile()"><a id="TOC Juvenile" href="#section-juvenile">Juvenile</a></li>
         <li class="inline" *ngIf="juvenileCase.getAllegationsList().length !==0"><a id="TOC Allegations" href="#section-allegations">Allegations</a></li>
         <li class="inline" *ngIf="juvenileCase.getEventList().length !==0"><a id="TOC Events" href="#section-events">Events</a></li>
         <li class="inline" *ngIf="juvenileCase !== undefined"><a id="TOC Case Information" href="#section-case-information">Case Information</a></li>
          <li class="inline" *ngIf="juvenileCase.getPartyList().length !==0">
          <a id="TOC Parties Details" href="#section-party-details">Parties</a><a class="dropdown-toggle" data-toggle="dropdown" href="#"><span class="caret"></span></a>
          <ul class="dropdown-menu scrollable-menu" role="menu">
           <li *ngFor="let party of juvenileCase.getPartyList()">
              <a [href]="'#P-' + party.getPartyKey()" data-scrollspy-offset-px="50">{{party.getJuvenileName()}} ({{party.getPartyType()}})</a>
            </li>
          </ul>
        </li>
        <!-- End Attorney Case Detail -->

        <!-- <li class="inline" *ngIf="juvenileCase.getAttorneyList().length !== 0"><a id="TOC Attorneys" href="#section-attorneys">Attorneys</a></li> -->
        <br>
        <li *ngIf="!isProd()"><div class="show-field-code" title="{{showFieldCodeAction}}" (click)="showFieldCode()"></div></li>
      </ul>
    </nav>

    <div id="content-column" class="panel-group" [ngClass]="{'toc-opened': tocOpen, 'toc-closed': !tocOpen}">
      <div id="juvenile-case-view-toc-controls-outer-div" (click)="toggleTableOfContents()"
        [title]="tocOpen ? 'Close table of contents' : 'Open table of contents'">
        <div id="juvenile-case-view-toc-controls-inner-div">
            <i id="juvenile-case-view-toc-controls-arrow" class="fa fa-2x" [ngClass]="{'fa-chevron-circle-left': tocOpen, 'fa-chevron-circle-right': !tocOpen}" aria-hidden="true"></i>
          </div>
      </div>

            <!-- Begin Juvenile -->
            <div class="panel panel-default page" id="section-juvenile" *ngIf="juvenileCase.getJuvenile()">
              <div class="panel-heading">
                <h3 class="panel-title summary-label">Juvenile</h3>
              </div>
              <div class="panel-collapse collapse in" style="height: auto;">
                <app-juvenile [juvenileCase]="juvenileCase"></app-juvenile>
              </div>
              <div class="title-bar">
                <h3 id="Juvenile" class="panel-title summary-label">Juvenile</h3>
              </div>
            </div>
            <!-- End Juvenile -->

            <!-- Begin Allegations -->
            <div class="panel panel-default page" id="section-allegations" *ngIf="juvenileCase.getAllegationsList().length !==0">
              <div class="panel-heading">
                <h3 class="panel-title summary-label">Allegations</h3>
              </div>
              <div class="panel-collapse collapse in" style="height: auto;">
                <app-allegations [juvenileCase]="juvenileCase"></app-allegations>
              </div>
              <div class="title-bar">
                <h3 id="Allegations" class="panel-title summary-label">Allegations</h3>
              </div>
            </div>
            <!-- End Allegations -->

            <!-- Begin Events -->
            <div class="panel panel-default page" id="section-events" *ngIf="juvenileCase.getEventList().length !==0">
              <div class="panel-heading">
                <h3 class="panel-title summary-label">Events</h3>
              </div>
              <div class="panel-collapse collapse in" style="height: auto;">
                <app-events [juvenileCase]="juvenileCase"></app-events>
              </div>
              <div class="title-bar">
                <h3 id="Events" class="panel-title summary-label">Events</h3>
              </div>
            </div>
            <!-- End Events -->
      
      <!-- Begin Case Information -->
      <div class="panel panel-default page" id="section-case-information" *ngIf="juvenileCase !== undefined">
        <div class="panel-heading">
          <h3 class="panel-title summary-label">Case Information</h3>
        </div>
        <div class="panel-collapse collapse in" style="height: auto;">
          <app-juvenile-case-information [juvenileCase]="juvenileCase"></app-juvenile-case-information>
        </div>
        <div class="title-bar">
          <h3 id="Case Information" class="panel-title summary-label">Case Information</h3>
        </div>
      </div>
      <!-- End Case Information -->
     
      <!-- Begin Parties -->
      <div class="panel panel-default page" id="section-party-details" *ngIf="juvenileCase.getPartyList().length !==0">
        <div class="panel-heading">
          <h3 class="panel-title summary-label">Parties</h3>
        </div>
        <div class="panel-collapse collapse in" style="height: auto;">
          <app-parties-details [juvenileCase]="juvenileCase"></app-parties-details>
        </div>
        <!--<div class="title-bar panel-heading">-->
        <div class="title-bar">
          <h3 id="Parties Details" class="panel-title summary-label">Parties</h3>
        </div>
      </div>
      <!-- End Parties -->      


      <div style="height:1000px"></div>
    </div>
    </div>
</div>



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/case-view/juvenile/juvenile-case-view.component.html